import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownMenuItem } from '@bibliocommons/base-dropdown';
import BatchActionLink from '../../../shared/BatchActions/BatchActionLink';
import ImmutablePropTypes from 'react-immutable-proptypes';

export default function CancelHoldBatchAction({ items, handleClick }) {
  const cancelItems = items.filter((item) => item.get('actions').includes('cancel'));

  return (
    <DropdownMenuItem key="cancel-hold-batch-cancel" className="cp-cancel-hold-batch-action">
      <BatchActionLink
        disabled={cancelItems.size === 0}
        href="#cancel-hold-batch-cancel"
        handleClick={() => handleClick(cancelItems)}>
        <FormattedMessage id="cancel_holds_with_count" values={{ count: cancelItems.size }} />
      </BatchActionLink>
    </DropdownMenuItem>
  );
}

CancelHoldBatchAction.propTypes = {
  items: ImmutablePropTypes.map,
  handleClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/CancelHoldBatchAction/CancelHoldBatchAction.jsx